import { TableHead } from '@/components/ui/table'
import { ArrowDown, ArrowUp } from 'lucide-react'

interface SortableTableHeadProps<TColumn extends string> {
  column: TColumn
  label: string
  sortBy: TColumn | null
  sortDirection: 'asc' | 'desc'
  defaultDirections: Record<TColumn, 'asc' | 'desc'>
  onSortChange: (column: TColumn) => void
  className?: string
}

export function SortableTableHead<TColumn extends string>({
  column,
  label,
  sortBy,
  sortDirection,
  defaultDirections,
  onSortChange,
  className,
}: SortableTableHeadProps<TColumn>) {
  const isActive = sortBy === column
  const nextDirection = isActive
    ? (sortDirection === 'asc' ? 'desc' : 'asc')
    : defaultDirections[column]
  const CurrentArrow = sortDirection === 'desc' ? ArrowDown : ArrowUp
  const NextArrow = nextDirection === 'desc' ? ArrowDown : ArrowUp
  return (
    <TableHead
      className={className}
      aria-sort={isActive ? (sortDirection === 'asc' ? 'ascending' : 'descending') : undefined}
    >
      <button
        type="button"
        className="group flex items-center gap-1 hover:text-foreground transition-colors"
        onClick={() => onSortChange(column)}
        aria-label={`Sort by ${label} ${nextDirection === 'asc' ? 'ascending' : 'descending'}`}
      >
        {label}
        {isActive ? (
          <>
            <CurrentArrow className="h-3 w-3 group-hover:hidden" />
            <NextArrow className="hidden h-3 w-3 opacity-50 group-hover:inline" />
          </>
        ) : (
          <NextArrow className="h-3 w-3 opacity-0 transition-opacity group-hover:opacity-50" />
        )}
      </button>
    </TableHead>
  )
}
